import React from 'react';
import { MemoryRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useAppLanguage } from '@/core/hooks/useAppLanguage';
import { MetricsSideBar } from './components/MetricsSideBar/MetricsSideBar';

export interface MetricsMenuAppProps extends React.ComponentProps<typeof MetricsSideBar> {
  initialEntries?: string[];
}

export const MetricsMenuApp: React.FC<MetricsMenuAppProps> = ({ initialEntries, ...props }) => {
  useAppLanguage();

  return (
    <MemoryRouter initialEntries={initialEntries}>
      <Routes>
        <Route path="/" element={<MetricsSideBar {...props} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </MemoryRouter>
  );
};